import { GET } from './api'

export const ReadMyCertificates = async ({ page = 1, pageSize = 24 } = {}) => GET(
  `/course-certificates?pagination[page]=${page}&pagination[pageSize]=${pageSize}&sort=issued_at:desc`,
  true
)
